import React from 'react'
import { Button } from '@smooth-ui/core-em'

const ButtonCustom = props => {
  const { form, success, back, ...other } = props
  let customProps = {}

  if (form) {
    customProps = {
      ...customProps,
      height: '50px',
      fontWeight: 'bold',
      width: '100%',
    }
  }

  if (success) {
    customProps = {
      ...customProps,
      variant: 'success',
    }
  } else if (back) {
    customProps = {
      ...customProps,
      variant: 'light',
    }
  }

  return (
    <Button {...other} {...customProps}>
      {props.children}
    </Button>
  )
}

export default ButtonCustom



// WEBPACK FOOTER //
// ./src/UILibrary/Button.js